document.addEventListener('DOMContentLoaded', () => {
  // Création de l'overlay et du modal
  const modalOverlay = document.createElement('div');
  modalOverlay.className = 'br-contact-modal-overlay';

  const modal = document.createElement('div');
  modal.className = 'br-contact-modal';

  const closeButton = document.createElement('span');
  closeButton.className = 'modal-close';
  closeButton.innerHTML = '&times;';
  closeButton.addEventListener('click', closeModal);

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  function closeModal() {
    modalOverlay.style.display = 'none';
    modal.classList.remove('loaded');
  }

  // Header + body du modal
  const header = document.createElement('div');
  header.className = 'br-modal-header';

  const body = document.createElement('div');
  body.className = 'br-modal-body';

  modal.appendChild(header);
  modal.appendChild(body);
  modal.appendChild(closeButton);
  modalOverlay.appendChild(modal);
  document.body.appendChild(modalOverlay);

  // Ouvrir le modal au clic sur une carte
  document.body.addEventListener('click', (e) => {
    const card = e.target.closest('.br-contact-card');
    if (!card) return;

    const name = card.querySelector('h3')?.textContent?.trim() || '';
    const title = card.dataset.title || '';
    const title2 = card.dataset.title2 || '';
    const companyRaw = card.dataset.company || '';
    const country = card.dataset.country || '';

    // Normalisation du nom d'organisation
    const normalizedCompany = companyRaw
      .toLowerCase()
      .replace(/[\s\-_.]/g, '')
      .trim();

    let logoUrl = card.dataset.logo || '';

    if (!logoUrl && (
      normalizedCompany === 'itu' ||
      normalizedCompany === 'itur' ||
      normalizedCompany === 'itut' ||
      normalizedCompany === 'internationaltelecommunicationunion'
    )) {
      logoUrl = 'https://www.itu.int/PublishingImages/masterpage/logos/ITU-logo.svg';
    }

    const img = card.querySelector('img')?.cloneNode(true);
    const bioEl = card.querySelector('.br-contact-bio');
    const bio = bioEl?.textContent?.trim();

    if (!bio) return;

    // Nettoyage
    header.innerHTML = '';
    body.innerHTML = '';

    // Header
    const headerRow = document.createElement('div');
    headerRow.className = 'br-modal-header-line';

    const nameSpan = document.createElement('span');
    nameSpan.className = 'br-modal-name';
    nameSpan.textContent = name;

    const metaText = [title, title2, companyRaw, country].filter(Boolean).join(' - ');
    const metaSpan = document.createElement('span');
    metaSpan.className = 'br-modal-meta';
    metaSpan.textContent = metaText;
    if (metaText) metaSpan.title = metaText;

    headerRow.appendChild(nameSpan);
    headerRow.appendChild(metaSpan);
    header.appendChild(headerRow);
    header.appendChild(closeButton);

    // BODY : photo + logo + bio
    const photoWrapper = document.createElement('div');
    photoWrapper.className = 'modal-photo';

    if (img) {
      photoWrapper.appendChild(img);

      if (logoUrl) {
        const logoSection = document.createElement('div');
        logoSection.className = 'modal-logo-section';
        logoSection.style.marginTop = '20px';
        logoSection.style.textAlign = 'center';

        const separator = document.createElement('div');
        separator.style.height = '1px';
        separator.style.background = '#e5f5fb';
        separator.style.margin = '10px auto';

        const logoImg = document.createElement('img');
        logoImg.src = logoUrl;
        logoImg.alt = 'Company Logo';
        logoImg.style.maxWidth = '50%';
        logoImg.style.height = 'auto';
        logoImg.style.display = 'block';
        logoImg.style.margin = '10px auto 0';
        logoImg.style.border = 'none';
        logoImg.style.boxShadow = 'none';
        logoImg.style.background = 'transparent';
        logoImg.style.borderRadius = '0';

        logoSection.appendChild(separator);
        logoSection.appendChild(logoImg);
        photoWrapper.appendChild(logoSection);
      }
    }

    const bioWrapper = document.createElement('div');
    bioWrapper.className = 'modal-bio';
    bioWrapper.innerHTML = `<p>${bio.replace(/\n/g, '</p><p>')}</p>`;

    body.appendChild(photoWrapper);
    body.appendChild(bioWrapper);

    modalOverlay.style.display = 'flex';
    modal.classList.add('loaded');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });
});
